import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import {
  AuthUrlResponse,
  FiUserService,
} from '@app/service/fi-user-service/fi-user.service';
import { StateService } from '@app/service/state/state.service';
import { FiRoute } from '@assets/val/route-constants';
import { LoggingService } from '@app/service/logging-service/logging.service';
import { QueryParamsService } from '@app/service/query-params/query-params.service';

import Translations from './fi-authenticate-scrive.component.json';

@Component({
  selector: 'app-fi-authenticate-scrive',
  templateUrl: './fi-authenticate-scrive.component.html',
  styleUrls: [
    '../../page-shared.css',
    './fi-authenticate-scrive.component.scss',
  ],
})
export class FiAuthenticateScriveComponent
  extends RouteComponent
  implements OnInit
{
  public authInProgress = false;
  public authComplete = false;

  loading: boolean = true;
  error: boolean = false;
  navigationInProgress: boolean = false;

  translations: { [key: string]: string };

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    protected queryParamsService: QueryParamsService,
    private fiUserService: FiUserService,
    private loggingService: LoggingService
  ) {
    super(router, route, stateService, headerService);
  }

  async ngOnInit(): Promise<void> {
    this.translations =
      Translations[
        this.fiUserService.getCurrentStateLocaleBaseCode(this.state.language)
      ];

    const success = this.queryParamsService.getQueryParams().success;
    const transaction_id =
      this.queryParamsService.getQueryParams().transaction_id;

    if (success === 'false') {
      this.error = true;
      return;
    }

    if (success && transaction_id) {
      this.loggingService.log(
        `Came back from Scrive with following params: ?transaction_id=${transaction_id}&success=${success}`
      );
      this.handleCallback(success === 'true');
      return;
    }

    this.loading = false;
  }

  async handleCtaClick() {
    this.authInProgress = true;

    try {
      const returnUrl: string = window.location.href;
      await this.fiUserService
        .initAuth(returnUrl)
        .then((resp: AuthUrlResponse) => {
          this.loggingService.log('Leaving checkout to enter Scrive Auth flow');
          window.location.href = resp.accessUrl;
        });
    } catch (err) {
      this.handleError(err);
      // navigate on error to avoid hanging in loading state
      this.navigate();
    }
  }

  async handleCallback(success: boolean) {
    if (success) {
      this.authComplete = true;
      try {
        await this.fiUserService.authorize().then(() => this.navigate());
      } catch (err) {
        this.handleError(err);
        // navigate on error to avoid hanging in loading state
        this.navigate();
      }
    } else {
      this.authInProgress = false;
      return;
    }
  }

  async handleCancellation(): Promise<void> {
    this.navigationInProgress = true;
    this.router.navigate([FiRoute.HOME], {
      queryParams: {
        // Never preserve these params:
        transaction_id: null,
        success: null,
      },
      queryParamsHandling: 'merge',
    });
    this.navigationInProgress = false;
  }

  getPartEightDisclaimer(): string {
    return this.translations.disclaimerPartEight.replace(
      '${MERCHANT}',
      this.state.checkoutCustomizations.merchantName
    );
  }
}
